// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import useHttp from "hooks/use-http";

// material styles
import { Grid, Button } from "@mui/material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import ProgressBarCM from "components/shared/ProgressBar";
import Modal from "components/shared/Modal";

import { StyledAnswer } from "./showExcellScores.style";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// request methods
import { getScoresExamAnswersByIdRequest } from "api/requests";

import { useNavigate, useParams } from "react-router-dom";
import BackButton from "components/shared/BackButton";
import { StyledLink } from "components/shared/Link";
import { PY_IMG_BASE_URL } from "constants";

// excell scores head cells
const headCells = GenerateHeadCell("testScores_view_list");

const arrStudent = [];
const arr = [];

export default function ShowExcellScores() {
  const { scores_excell_file_id } = useParams();
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const {
    request,
    loading,
    isUploading,
    setLoading,
    setUploadProgress,
    uploadProgress,
  } = useHttp(false);

  // excellScores data state
  const [excellScoresData, setExcellScoresData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);
  const [enable, setEnable] = useState(null);
  const [showModalCorrect, setShowModalCorrect] = useState(false);

  const handelShowCorrectModal = () => setShowModalCorrect((state) => !state);

  const getScoresExcellFileData = useCallback(async () => {
    const res = await request({
      url: getScoresExamAnswersByIdRequest,
      values: { id: scores_excell_file_id },
    });
    if (res) {
      if (res.data.exam_answers.length < 1) {
        return setExcellScoresData({
          data: [{ content: "اطلاعات یافت نشد" }],
          count: 0,
        });
      }
      setEnable(res.data.is_enabled);

      arr.splice(0, arr.length);
      for (let key in res.data.answer_sheet) {
        arr.push(res.data.answer_sheet[key]);
      }

      let transformedData = res?.data?.exam_answers.map((item) => ({
        id: item.id,
        full_name: `${item.student.first_name} ${item.student.last_name}`,
        percentage: item?.percentage ?? "-",
        // score: item?.percentage ?? "-",
        rank: item?.rank ?? "-",
        correct: item?.correct ?? "-",
        not_ans: item?.not_answered ?? "-",
        wrong: item?.incorrect ?? "-",
        answer_sheet: (
          <>
            {item.answers_image == null ? (
              ""
            ) : (
              <StyledLink
                to={PY_IMG_BASE_URL + item.answers_image}
                target="_blank"
                style={{ marginTop: "2px", marginBottom: "2px" }}
              >
                <Button color="success" variant="outlined">
                  دانلود
                </Button>
              </StyledLink>
            )}
          </>
        ),
        answers: (
          <>
            {item.answers_image == null ? (
              ""
            ) : (
              <Button
                color="success"
                variant="outlined"
                onClick={(e) => {
                  arrStudent.splice(0, arrStudent.length);
                  e.stopPropagation();
                  handelShowCorrectModal();
                  for (let key in item.answers) {
                    arrStudent.push(item.answers[key]);
                  }
                }}
              >
                نمایش
              </Button>
            )}
          </>
        ),
      }));
      setExcellScoresData({
        data: transformedData,
        count: transformedData.length,
      });
    }
  }, []);
  useEffect(() => {
    getScoresExcellFileData();
  }, [page]);

  return (
    <DrawerCM title="مشاهده نمرات " $styledHeader>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton />
            </Grid>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست نمرات "
                rows={excellScoresData.data}
                headCells={headCells}
                page={page}
                colspan={excellScoresData.count === 0 ? "8" : ""}
                fontSize="14px"
                cellFontSize="14px"
              />
            </Grid>
          </Grid>
          <Modal
            title={"پاسخ ها"}
            show={showModalCorrect}
            onClose={handelShowCorrectModal}
          >
            <Grid
              container
              style={{ color: "black", direction: "rtl", marginBottom: "40px" }}
            >
              <Grid item xs={6}>
                <h5>پاسخ نامه اصلی</h5>
                {arr?.map((item, index) => (
                  <StyledAnswer key={index}>
                    <span> {index + 1} : </span>
                    <span>{item == null ? "ثبت نشده" : " گزینه " + item}</span>
                  </StyledAnswer>
                ))}
              </Grid>
              <Grid item xs={6}>
                <h5>پاسخ دانش آموز</h5>
                {arrStudent?.map((item, index) => (
                  <StyledAnswer key={index}>
                    <span> {index + 1} : </span>
                    <span>{item == null ? "نزده" : " گزینه " + item}</span>
                  </StyledAnswer>
                ))}
              </Grid>
            </Grid>
          </Modal>
        </Fragment>
      )}
    </DrawerCM>
  );
}
